import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="container p-4" style={{ textAlign: 'center', padding: '50px', fontFamily: 'Arial, sans-serif' }}>
      <h1 style={{ fontSize: '72px', color: '#ff4d4f' }}>404</h1>
      <h2 style={{ fontSize: '24px', color: '#555' }}>Page Not Found</h2>
      <p style={{ fontSize: '16px', color: '#777' }}>
        Oops! The page you are looking for does not exist. It might have been moved or deleted.
      </p>
      <Link
        to="/"
        style={{
          display: 'inline-block',
          marginTop: '20px',
          padding: '10px 20px',
          backgroundColor: '#007bff',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '5px',
        }}
      >
        Go Back to Home
      </Link>
    </div>
  );
};

export default NotFound;